export default __webpack_public_path__ + "static/media/linkedin.04ca593c.svg";